import { InputText } from "primereact/inputtext";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { syntageCss } from "./ResetPassword.css.js";
import { Button } from "primereact/button";
import { Controller, set, useForm } from "react-hook-form";
import axios from "axios";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Checkbox } from 'primereact/checkbox';
import { Loader } from "../../Components/index.js";
import { AuthContext } from "../../Context/AuthContext.jsx";
import { url } from "../../env.js";


function ResetPassword({ }) {

  const [searchParams] = useSearchParams(); // Para obtener los query parameters
  const token = searchParams.get('token').split("?")[0]; // Obtiene el token de la URL

  const [showPassword, setShowPassword] = useState(false);

  const { logout } = useContext(AuthContext);

  // Cerrar cualquier sesión previa al entrar a la pantalla de recuperación.
  // Si no se hace, el AuthContext puede restaurar la sesión del usuario anterior
  // (token persistente en localStorage) y al redirigir a /login después del reset
  // el navegador entra como ese usuario en vez de exigir login fresco.
  useEffect(() => {
    if (localStorage.getItem("token")) {
      logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  let id = params.get("id");

  // console.log(authInfo, "authInfoauthInfo", secret);

  const defaultValues = {
    password: null,
    confirmPassword: null,
    email: null,
  };

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    control,
    setValue,
  } = useForm({ defaultValues });

  const [isErrorFetching, setIsErrorFetching] = useState(false);
  const [message, setMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

useEffect(() => {
    if (!token) {
      setIsErrorFetching(true);
      setMessage("Token inválido, por favor intenta de nuevo.");
    }
  }, [token]);

  useEffect(() => {
    if (token) {
      setLoading(true);
      axios.get(`${url}/password/validToken/${token}`)
        .then((response) => {
          if (response.data.status === 200) {
            setValue("email", response.data.email);
            setLoading(false);

          } else {
            setIsErrorFetching(true);
            setMessage("Token inválido, por favor intenta de nuevo.");
      setLoading(false);

          }
        })
        .catch((error) => {
          setIsErrorFetching(true);
          setMessage("Token inválido, por favor intenta de nuevo.");
      setLoading(false);

        });
    }
  }, []);



  const submit = (data) => {

    const { password, email } = data;
    setLoading(true);
    axios.post(`${url}/password/reset`, {
      password,
      email,
      token,
    })
      .then((response) => {
        if (response.data.status === 200) {
          setLoading(false);

          // Borrar cualquier token previo antes de instalar el nuevo (evita
          // que un token viejo de otra cuenta interfiera en el reload).
          localStorage.removeItem("token");

          // Auto-login: si el backend devolvió token + tipo de usuario, lo
          // guardamos y redirigimos al dashboard que le corresponde.
          if (response.data.token) {
            localStorage.setItem("token", response.data.token);
            const t = String(response.data.type_user ?? "");
            let target;
            if (response.data.url) {
              target = response.data.url;
            } else if (t === '1') {
              target = `${window.location.origin}/admin`;
            } else if (t === '3') {
              target = `${window.location.origin}/admin-trim`;
            } else if (t === '2' || t === '4') {
              target = `${window.location.origin}/vendedor`;
            } else {
              target = `${window.location.origin}/login`;
            }
            window.location.href = target;
            return;
          }

          // Fallback (backend antiguo sin token): manda al login.
          if (response.data.url) {
            window.location.href = response.data.url;
          } else {
            window.location.href = `${window.location.origin}/login`;
          }

        } else {
          setLoading(false);
          setIsErrorFetching(true);
          setMessage(response.data.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        setIsErrorFetching(true);
        setMessage("Ha ocurrido un error, por favor intenta de nuevo.");
        // navigate("/login");
      });

  }
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (

    <div css={syntageCss()}>
      {loading &&
        <div style={{
          zIndex: 1000,
        }}>
          <Loader />
        </div>
      }
      <div className="ResetPassword" 
        style={{
          maxWidth: "35rem",
          minWidth: "5rem",
          margin: "auto",
        }}
      >

        <div className="Background" />

        <div className="TopText">Recupera tu contraseña</div>
        <div className="TopText2 pb-6">
          <span>
            Ingresa tu nueva contraseña
          </span>
        </div>

        <div className="flex flex-column align-items-center FormContainer">
          {isErrorFetching ? (
            <div className="ErrorMessage"
              style={{ width: "100%", textAlign: "center" , height: "4rem" }}
            >
              <span className="ErrorText"> Hubo un error o el token ha expirado. </span>
              <span className="ErrorText"> Por favor, vuelva a intentarlo. </span>
              <Button 
              label="Regresar"
              className="w-full Green Button py-3"
              style={{marginTop: "1rem"}}
              onClick={() => navigate("/login", { replace: true })}
              />
            </div>
          ) :

            <form className="grid" onSubmit={handleSubmit((data) => submit(data))}>
              <div className="col-12 p-2">
                <InputText
                  // tooltip={errors["email"] ? 'Ingrese un correo válido' : null}
                  // tooltipOptions={{ event: 'focus', position: 'top' }}
                  maxLength={50}
                  {...register("email", {
                    required: true,
                    // pattern: /^[A-Za-z0-9]{12,13}$/, // Patrón para permitir solo letras y números y de longitud 12 a 13
                    maxLength: 50,
                  })}
                  disabled
                  placeholder="Correo Electrónico"
                  className={
                    "EmailInput w-full TextInput " +
                    `${errors["email"] ? "p-invalid" : ""}`
                  }
                  type="email"
                />
              </div>



              <IconField iconPosition="right" className="w-full relative">
  <div className="col-12 p-2">
    <InputText
      maxLength={50}
      {...register("password", {
        required: true,
        minLength: {
          value: 8,
          message: "La contraseña debe tener al menos 8 caracteres",
        },
        maxLength: 50,
      })}
      type={showPassword ? "text" : "password"}
      placeholder="Contraseña"
      className={
        "EmailInput w-full TextInput " +
        `${errors["password"] ? "p-invalid" : ""}`
      }
    />
    {errors.password && (
      <p className="p-error">{errors.password.message}</p>
    )}
  </div>
  <InputIcon
    onClick={handleTogglePassword}
    style={{
      zIndex: "100",
      marginBottom: "1em",
      top: "1.5em",
      right: "1.8em",
    }}
    className={
      showPassword
        ? "pi pi-eye-slash pointer eyePassMobile"
        : "pi pi-eye pointer eyePassMobile"
    }
  ></InputIcon>
</IconField>

<div className="col-12 p-2">
  <InputText
    maxLength={50}
    {...register("confirmPassword", {
      required: true,
      minLength: {
        value: 8,
        message: "La contraseña debe tener al menos 8 caracteres",
      },
      maxLength: 50,
      validate: (value) =>
        value === watch("password") || "Las contraseñas no coinciden",
    })}
    type="password"
    placeholder="Confirma tu Contraseña"
    className={
      "EmailInput w-full TextInput " +
      `${errors["confirmPassword"] ? "p-invalid" : ""}`
    }
  />
  {errors.confirmPassword && (
    <p className="p-error">{errors.confirmPassword.message}</p>
  )}
</div>





              <div className="Container">
                {isErrorFetching && (
                  <div className="ErrorMessage">
                    <span className="ErrorText"> {message}</span>
                  </div>
                )}
              </div>

              <div className={`col-12 p-2 ButtonContainer `}>
                <Button
                  label="Continuar"
                  className="w-full Green Button py-3"
                  type="submit"
                />

              </div>
              <div className="col-12 flex justify-content-center pt-6">
                <div
                  className="shadowCard "
                  style={{ height: "2rem", width: "80%" }}
                />
              </div>
            </form>
          }
        </div>
      </div>
    </div>

  );
}

export { ResetPassword };
